export default "__VITE_ASSET__FIAaxku5__"